import { LazyPromise } from '@zajno/common/lazy/promise';
import AppConfig from 'common/config';
import type { SupabaseClientOptions } from '@supabase/supabase-js';
import type { Database } from 'common/types/db';
import logger from 'common/logger';

export type * as SupabaseTypes from '@supabase/supabase-js';

let ClientOptions: SupabaseClientOptions<'public'> = undefined;

const getOptions = () => (ClientOptions || (ClientOptions = {}));
const getAuthOptions = () => getOptions().auth || (getOptions().auth = {});

/** call it before accessing `Supabase` instance (or at least before it's loaded) to take effect */
export const setAuthPersistence = (value: boolean) => { getAuthOptions().persistSession = value; };

export const Supabase = new LazyPromise(async () => {
    const lib = await import('@supabase/supabase-js');

    logger.log('Supabase: initializing client with url =', AppConfig.Supabase.url, 'key = ...', AppConfig.Supabase.key.substring(AppConfig.Supabase.key.length - 10));
    const client = lib.createClient<Database>(AppConfig.Supabase.url, AppConfig.Supabase.key, ClientOptions);

    return {
        client,
        lib,
    };
});

export type SupabaseClient = Awaited<typeof Supabase.value['client']>;
export type SupabaseLib = Awaited<typeof Supabase.value['lib']>;
